/***
 * Created on 2023/8/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/


export function getLocalUser() {
    let currentUser;
    if (!currentUser) {
        currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }
    return currentUser;
}

export function setLocalUser(user) {
    if (user) {
        localStorage.setItem('currentUser', JSON.stringify(user));
    }
}

export function getPrimaryEmail(user) {
    let currentUser = user;
    if (!currentUser) {
        currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }
    if (!currentUser) return undefined;

    const email = currentUser.emails?.filter(email => email.is_primary && email.is_verified).map(email => email.email);
    return email?.[0] ? email[0] : undefined;
}

export function getPrimaryPhone(user) {
    let currentUser = user;
    if (!currentUser) {
        currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }
    if (!currentUser) return undefined;

    const phone = currentUser.phones?.filter(phone=> phone.is_primary && phone.is_verified).map(phone=> ({phone:phone.number, country_code:phone.country_code}));
    return phone?.[0] ? phone[0] : undefined;
}

export function getPrimaryQid(user) {
    return getPrimaryEmail(user) || getPrimaryPhone(user)?.phone;
}

export function checkQIDFormat(qid) {
    const email_pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
    const phone_pattern = /^\d{6,16}$/;
    let qid_type = null
    if (email_pattern.test(qid)) {
        qid_type = 'email'
    }
    else if (phone_pattern.test(qid)) {
        qid_type = 'phone'
    }
    return qid_type
}